import styled from 'styled-components'

export const ConfigContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`
export const Header = styled.header`
  width: 100%;
  height: 16.8rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  @media (max-width: 1000px) {
    height: auto;
  }
`
export const HeadSection = styled.section`
  width: 100%;
  height: 7rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 1.6rem;
  border-radius: 4px;
  border-bottom: 1.5px solid #dde0e5;

  @media (max-width: 1000px) {
    height: 8.6rem;
  }
  @media (max-width: 768px) {
    height: auto;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  @media (max-width: 500px) {
    align-items: center;
  }
`
export const Title = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  & > h1 {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 0.4rem;
  }
  & > p {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    margin-bottom: 0;
  }
  @media (max-width: 768px) {
    margin-bottom: 0.8rem;
  }
`
export const DetailSection = styled.section`
  width: 100%;
  height: 9.4rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 2.4rem 0 2.4rem 0;
  @media (max-width: 500px) {
    display: none;
  }
`
export const RoleDetails = styled.div`
  max-width: 100%;
  height: 5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
export const RoleIcon = styled.span`
  width: 3.6rem;
  height: 3.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #bae0ff;
  border-radius: 50%;
  & > svg {
    width: 2rem;
    height: 2rem;
    color: #0958d9;
  }
  & > span {
    margin: 0 !important;
    & > svg {
      width: 2rem;
      height: 2rem;
      color: #0958d9;
    }
  }
`
export const DetailsTitle = styled.div`
  max-width: 100%;
  height: 5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-left: 1.6rem;

  & > p {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    margin: 0;
  }
`
export const RoleTitle = styled.div`
  width: auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  & > h1 {
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    margin: 0 1.2rem 0 0;
  }
`
export const ActiveUsersTag = styled.span`
  width: 13rem;
  height: 2.2rem;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.24px;
  color: #0958d9;
  background-color: #bae0ff;
  border-radius: 0.4rem;
  padding: 0 0.8rem 0 0.8rem;
  @media (max-width: 600px) {
    display: none;
  }
`
export const ConfigBody = styled.main<{ showFooter: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border: 1px solid #dde0e5;
  border-radius: 0.8rem;
  margin-bottom: ${({ showFooter }) => (showFooter ? '7.2rem' : '0')};
  @media (max-width: 720px) {
    border: none;
  }
`
export const ConfigModuleList = styled.ul<{ show: boolean }>`
  width: 27.8rem;
  min-width: 27.8rem;
  height: 100%;
  padding: 1.2rem;
  border-radius: 8px 0px 8px 8px;
  background: #f3f5f9;
  list-style: none;
  @media (max-width: 720px) {
    width: 32.8rem;
    display: ${({ show }) => (show ? 'none' : 'block')};
  }
  @media (max-width: 500px) {
    margin-top: 1.6rem;
  }
`
export const ModuleListItem = styled.li<{ selected: boolean; active: boolean }>`
  width: 100%;
  height: 4rem;
  display: flex;
  padding: 8px 12px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 6px;
  background: ${({ selected }) => (selected ? '#1677FF' : 'transparent')};
  color: ${({ selected }) => (selected ? '#ffffff' : 'rgba(0, 0, 0, 0.85)')};
  cursor: pointer;

  & > div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  & > div > svg,
  & > div > span > svg {
    width: 2.4rem;
    height: 2.4rem;
    margin-right: 0.8rem;
    color: ${({ selected, active }) => (selected && active ? '#ffffff' : !active ? 'rgba(0, 0, 0, 0.25)' : '#1677FF')};
  }
  & > div > p {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    margin: 0;
  }
  & > span {
    & > span:last-child {
      display: none;
    }
  }
  @media (max-width: 720px) {
    & > span {
      width: 7.5rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      & > span:last-child {
        display: block;
      }
    }
  }
`
export const OffTag = styled.span`
  width: 4.1rem;
  height: 2.2rem;
  padding: 0.1rem 0.8rem;
  border-radius: 4px;
  background: #dde0e5;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.24px;
  color: #000000;
  &:after {
    content: 'OFF';
  }
`
export const ModulePermissions = styled.section<{ show: boolean }>`
  width: calc(100% - 27.8rem);
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  @media (max-width: 720px) {
    width: 100%;
    display: ${({ show }) => (show ? 'flex' : 'none')};
  }
`
export const PermissionsHeader = styled.header`
  width: 100%;
  height: 8.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.6rem 2.4rem;
  border-radius: 0 0.8rem 0 0;
  background-color: #f3f5f9;
  @media (max-width: 1150px) {
    height: 14.4rem;
    flex-direction: column;
    align-items: space-between;
    justify-content: flex-start;
  }
  @media (max-width: 720px) {
    border-radius: 0.8rem;
  }
`
export const PermissionsTitle = styled.div`
  width: 58.3rem;
  max-width: 58.3rem;
  min-width: 26.4rem;
  height: 5rem;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  & > span {
    display: none;
    font-size: 2.4rem;
    margin-right: 0.8rem;
    color: #000000;
  }
  & > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    & > h2 {
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 28px;
      margin: 0;
    }
    & > p {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      margin: 0;
    }
  }

  @media (max-width: 1200px) {
    height: 7.2rem;
  }
  @media (max-width: 1000px) {
    width: 100%;
    min-width: 29.6rem;
  }
  @media (max-width: 720px) {
    & > span {
      display: block;
    }
  }
`
export const PermissionControls = styled.div<{ disabled: boolean }>`
  width: 40rem;
  height: 5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > span {
    width: 19.95rem;
    height: 2.4rem;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    color: #1677ff;
    text-align: center;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  }
  & > span:first-child {
    border-right: 1px solid #d1d4d9;
  }
  @media (max-width: 860px) {
    width: 100%;
    min-width: 29.6rem;
  }
`
export const SubModulesList = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 2.1rem 2.6rem;

  @media (max-width: 720px) {
    padding: 1.6rem 0;
  }
`
export const ModuleActivationCard = styled.article<{ active: boolean }>`
  width: 100%;
  min-width: 32.8rem;
  height: 7.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem 2.4rem;
  border-radius: 8px;
  background: ${({ active }) => (active ? '#e6f4ff' : '#eaedf3')};
  margin-bottom: 2.4rem;

  & > div {
    width: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-right: 2.4rem;

    & > h3 {
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      margin: 0;
    }
    & > p {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      margin: 0;
    }
  }
  @media (max-width: 1000px) {
    height: 9.4rem;
  }
`
export const PermissionsList = styled.ul`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  list-style: none;
  padding: 1.6rem;
  margin: 0;
  & > li:last-child {
    margin-bottom: 0;
  }
`
export const PermissionItem = styled.li`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2.4rem;

  & > div > p {
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 2.2rem;
    font-style: normal;
    margin: 0;
    color: rgba(0, 0, 0, 0.45);
  }
  & > div > p:first-child {
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.4rem;
    color: #565e6c;
    &::first-letter {
      text-transform: capitalize;
    }
  }
`
export const Footer = styled.footer`
  width: calc(100% - 8rem);
  height: 7.2rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 1.6rem 4.5rem;
  position: fixed;
  bottom: 0;
  left: 8rem;
  background: #fff;
  box-shadow: 0px 0.3px 12px 0px rgba(0, 0, 0, 0.15);

  & > button {
    margin-left: 0.8rem;
  }
`
